import axios from "axios";

// L'app Emergent sert toujours le frontend et le backend sur le même hôte
// (aperçu, production *.emergent.host et domaine personnalisé app.signaclean.fr).
// On utilise donc l'origine courante pour que les appels /api suivent le domaine
// servant la page ; repli sur REACT_APP_BACKEND_URL hors navigateur (tests/SSR).
const BACKEND_URL =
  (typeof window !== "undefined" && window.location && window.location.origin)
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "signa_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getToken()) {
      clearToken();
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(err) {
  const detail = err.response?.data?.detail;
  if (detail == null) return err.message || "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}

export function fileUrl(fileId) {
  return `${API}/files/${fileId}/download?auth=${getToken()}`;
}

export default api;
